/**
 * @generated SignedSource<<df962c1cc5a2130390992fb74cd267c3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdentityProvidersSettingsRootQuery$variables = Record<PropertyKey, never>;
export type IdentityProvidersSettingsRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccessControlSettingsPage_query" | "IdentityProviders_query">;
};
export type IdentityProvidersSettingsRootQuery = {
  response: IdentityProvidersSettingsRootQuery$data;
  variables: IdentityProvidersSettingsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IdentityProvidersSettingsRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessControlSettingsPage_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IdentityProviders_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IdentityProvidersSettingsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SAMLProvider",
        "kind": "LinkedField",
        "name": "samlProviders",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableSignout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "idpNamespace",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3aa6a6742755e552f45669730a799155",
    "id": null,
    "metadata": {},
    "name": "IdentityProvidersSettingsRootQuery",
    "operationKind": "query",
    "text": "query IdentityProvidersSettingsRootQuery {\n  ...AccessControlSettingsPage_query\n  ...IdentityProviders_query\n}\n\nfragment AccessControlSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment IdentityProviderCard_provider on SAMLProvider {\n  name\n  displayName\n  enableSignout\n  idpNamespace\n}\n\nfragment IdentityProviders_query on Query {\n  samlProviders {\n    id\n    ...IdentityProviderCard_provider\n  }\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n"
  }
};
})();

(node as any).hash = "c3a62d0401aca24c6767f47adcb8edf0";

export default node;
